import styled from 'styled-components';

export const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(217, 217, 217, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;
